/**
 * Clock Web verification mode IDs sent to the backend.
 * These are the authoritative backend integers for each method when the
 * timelog originates from myIntelli Clock Web (this app).
 *
 * Backend reference: id_verification_mode field on the timelogs endpoint.
 */
export const CLOCK_WEB_MODE = {
  facial: 11,
  pin: 13,
  card: 2,
} as const;

/**
 * Clock Mobile verification mode IDs for myIntelli Clock Mobile.
 * Kept here for completeness; not sent by this app — used for display logic.
 */
export const CLOCK_MOBILE_MODE = {
  facial: 10,
  pin: 14,
} as const;

/**
 * Canonical source string values stored in payload_timelog.source.
 * These are written to the server by this app and read back from remote timelogs.
 */
export const TIMELOG_SOURCE = {
  clockWeb: 'clock-web',
  clockMobile: 'clock-mobile',
  biometric: 'biometric',
  manual: 'manual',
  appWeb: 'app-web',
  appMobile: 'app-mobile',
} as const;

/** All valid backend verification mode IDs (1–17). */
export type VerificationModeId =
  | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9
  | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17;

/**
 * Icon keys used to select the SVG icon for a verification method or source.
 * Each key maps to a named SVG in VerificationIcon (PR 3).
 */
export type VerificationIconKey =
  | 'fingerprint'
  | 'card'
  | 'pin'
  | 'facial'
  | 'iris'
  | 'plate'
  | 'user'
  | 'pc'
  | 'mobile'
  | 'palm'
  | 'biometric'
  | 'appWeb'
  | 'appMobile'
  | 'clockWeb'
  | 'clockMobile'
  | 'manual'
  | 'unknown';
